import { isString, snakeCase, startCase } from 'lodash';

import { Query, QueryUpdaterCallback } from '@shared/api/types';
import { cn } from '@shared/utils/helpers';

import { ColumnConfiguration } from './DataTable.types';
import { DataTableSortButton } from './DataTableSortButton';
import { shouldRightAlign } from './helpers';

type DataTableHeaderProps<T> = {
  columns: ColumnConfiguration<T>[];
  hasActions: boolean;
  query: Query;
  onQueryChange: QueryUpdaterCallback;
};

export function DataTableHeader<T>({ columns, hasActions, query, onQueryChange }: DataTableHeaderProps<T>) {
  return (
    <thead>
      <tr className="border-b-2">
        {columns.map((column, index) => (
          <th
            key={column.name || index}
            className={cn('pl-4 first:pl-0 pr-4 last:pr-0 py-2 whitespace-nowrap', {
              'text-right': shouldRightAlign(column),
            })}
          >
            {column.sortable !== false && (isString(column.sortable) || column.name) ? (
              <DataTableSortButton
                sort={isString(column.sortable) ? column.sortable : snakeCase(column.name)}
                className="font-medium text-gray-600"
                currentSort={query.sort}
                onSort={(sort) => onQueryChange((query) => ({ ...query, sort }))}
              >
                {column.label ?? startCase(column.name)}
              </DataTableSortButton>
            ) : (
              <span className="font-medium text-gray-600">{column.label ?? startCase(column.name)}</span>
            )}
          </th>
        ))}
        {hasActions && <th></th>}
      </tr>
    </thead>
  );
}
